(async function(algolia) {
    'use strict';
  
    if (!algolia.config.autocomplete_enabled) return;
  
    const autocomplete = algolia.externals.autocomplete;
  
    const index_suffix = await algolia.config.index_suffix;
  
    algolia.searchClient.addAlgoliaAgent('Shopify Integration');
  
    if (algolia.config.dynamic_selector) {
      const search_url = algolia?.shopify?.routes?.search_url || `${window.Shopify.routes.root}/search`;
      const default_form_search = `form[action="${search_url}"]`;
      algolia.config.input_selector += `, ${default_form_search}`;
    }
    
    // Retrieve the container from Shopify's config
    const containers = Array.from(document.querySelectorAll(algolia.config.input_selector));
    containers.forEach(container => {
      container.innerHTML = ''
      const containerClasses = container.classList;
      containerClasses.add('aa-MainContainer');
    });
  
    // Set plugins
    const { productsPlugin, collectionsPlugin, articlesPlugin, pagesPlugin, querySuggestionsPlugin } = algolia;
    const plugins = [
      algolia.config.index_products && productsPlugin,
      algolia.config.index_collections && collectionsPlugin,
      algolia.config.index_articles && articlesPlugin,
      algolia.config.index_pages && pagesPlugin,
      algolia.config.autocomplete_query_suggestions && querySuggestionsPlugin
    ];
  
    const cssFile = document.getElementById('template_algolia_autocomplete.css');
    //Set CSS variables
    document.documentElement.style.setProperty(`--aa-text-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.secondary)}`);
    document.documentElement.style.setProperty(`--aa-primary-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.main)}`);
    document.documentElement.style.setProperty(`--aa-muted-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.muted)}`);
    document.documentElement.style.setProperty(`--aa-highlight-color-rgb`, `${algolia.helpers.hexToRGB(algolia.config.colors.highlight)}`);
    //Link CSS
    algolia.appendStyle(cssFile.text);

    const readSearchQuery = () => (
      document.querySelector('.site-search:not(.invisible) .aa-Input')?.value ||
      document.querySelector('.aa-Input')?.value ||
      document.querySelector('.search-input')?.value ||
      document.querySelector('input[name="q"]')?.value ||
      ''
    ).trim();

    const autocompleteOptions = {
      openOnFocus: true,
      debug: algolia.config.autocomplete_debug,
      insights: algolia.config.analytics_enabled,
      plugins,
      detachedMediaQuery: 'none',
      placeholder: window.translations.searchPlaceholderAlgolia,
      render({ elements, render, html, state }, root) {
        const sourceIdsToExclude = ['products'];
        const hasLeftPanelResults = state.collections
                .filter(
                        ({ source }) => sourceIdsToExclude.indexOf(source.sourceId) === -1
                )
                .reduce((prev, curr) => prev + curr.items.length, 0) > 0;
        const [querySuggestionsPluginResults] = state.collections.filter(({source}) => source.sourceId === 'querySuggestionsPlugin');
        const displaySuggestions = algolia.config.autocomplete_query_suggestions && querySuggestionsPluginResults.items.length > 0;
        render(
                hasLeftPanelResults ?
                algolia.mainTemplate({ html, state }, elements, displaySuggestions)
                : algolia.mainProductsTemplate({ html, state }, elements),
                root
        );
        // Do not display variant name if title contain 3 lines
        const cardContainers = document.querySelectorAll('.aa-ItemContentTitle');
        cardContainers.forEach(cardContainer => {
          const firstSpan = cardContainer.querySelector('span');
          const secondSpan = cardContainer.querySelector('.algolia-variant');
          if (firstSpan && secondSpan) {
            const maxChars = 18; 
            const textContent = firstSpan.textContent.trim();
            if (textContent.length > maxChars) {
              secondSpan.style.display = 'none';
            } else {
              secondSpan.style.display = ''; 
            }
          }
        });
         //custom
         if(window.bestSellers) {
          var popularItems = root.querySelectorAll('.popular-list')
          if(popularItems.length) {
            popularItems ? popularItems[0].classList.add('hidden') : null
          }
        }
      },
      renderNoResults({ render, html, state }, root) {
        //custom
        if(state.status === "loading") return;
        
        var bestSellers
        if(window.bestSellers) {
          bestSellers = window.bestSellers.products
          var popularItems = root.querySelectorAll('.popular-list')
          if(popularItems.length == 0) {
            var productList = document.createElement('ul')
            productList.classList.add('popular-list')
            bestSellers.forEach(product => {
              var liProduct = '<li class="popular-item"><a class="block border-none" href="products/'+ product.handle +'" title="'+ product.title +'"><img src="'+ product.first_image +'" alt="'+ product.title +'" class="w-100 aa-ItemPicture"><h3 class="text-base mt-1">' + product.title +'</h3></a></li>'
              productList.innerHTML += liProduct
            });
            root.childNodes.length > 0 ? root.childNodes[0].append(productList) : ''
          }
          else {
            popularItems ? popularItems[0].classList.remove('hidden') : null
          }
        }
        render(
                algolia.noResultsTemplate({ html, state, bestSellers }),
                root
        )
      },
      onSubmit({ state }) {
        const query = (state.query || readSearchQuery()).trim();
        if (!query) return;

        window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}`;
      }
    }
    
    window.__algoliaAutocompleteInstances = [];
    containers.forEach(container => {
      const instance = autocomplete({
        container,
        ...autocompleteOptions
      });
      window.__algoliaAutocompleteInstances.push(instance);
    });

    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const isSearchForm = form.classList.contains('search-bar')
        || form.classList.contains('aa-Form')
        || !!form.querySelector('.aa-Input')
        || !!form.querySelector('input[name="q"]');
      if (!isSearchForm) return;

      const query = (
        form.querySelector('.aa-Input')?.value ||
        form.querySelector('input[name="q"]')?.value ||
        readSearchQuery()
      ).trim();
      if (!query) {
        e.preventDefault();
        return;
      }

      let qInput = form.querySelector('input[name="q"]');
      if (!qInput) {
        qInput = document.createElement('input');
        qInput.type = 'hidden';
        qInput.name = 'q';
        form.appendChild(qInput);
      }
      qInput.value = query;
      e.preventDefault();
      window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}`;
    }, true);
  })(window.algoliaShopify);
  
  // "search-active" class is added when search input is focused
  document.addEventListener('focusin', (e) => {
    if (e.target.classList.contains('aa-Input')) {
      document.documentElement.classList.add('search-active');
    }
  });

  document.addEventListener('focusout', (e) => {
    if (e.target.classList.contains('aa-Input')) {
      setTimeout(() => {
        document.documentElement.classList.remove('search-active');
      }, 100);
    }
  });